import { useRecoilState, useResetRecoilState } from "recoil";
import { myTimesheetCurrentRoleState } from "my-timesheet/states";

export const useMySheetCurrentRoleState = () => {
  const [state, setState] = useRecoilState(myTimesheetCurrentRoleState);
  const resetState = useResetRecoilState(myTimesheetCurrentRoleState);
  return { state, setState, resetState };
};

export default useMySheetCurrentRoleState;
